import game from '../../app/api/game.js';
export default game;


// WEBPACK FOOTER //
// ./resources/assets/js/dragon/api/game.js